<template>
    <UserPageLayout hideTopRightMenu="true">
        <div class="max-w-md mx-auto pt-12">
            <div class="bg-white rounded shadow-lg px-5 py-6">
                <div>
                    <div class="text-center">
                        <i class="far fa-check-circle fa-5x text-green"></i>
                    </div>
                    <div class="text-center">
                        <h1 class="text-2xl shadow-text-none">{{ $t('vipps_login_success_title', { name }) }}</h1>
                        <p class="pb-6">
                            <span class="shadow-text-none">{{ $t('vipps_login_success_subtitle') }}</span>
                        </p>
                    </div>
                    <div class="text-center mt-3">
                        <button type="button" class="btn btn-lg text-xl font-opensans" @click="closeAction">
                            {{ $t('vipps_close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </UserPageLayout>
</template>

<script>
import { isLoggedIn, currentUser } from '@/lib/user.js'
import UserPageLayout from '@/layouts/UserPage'

export default {
    name: "VippsLoginLanding",

    components: {
        UserPageLayout
    },

    data () {
        return {
            name: ''
        }
    },

    mounted () {
        if (isLoggedIn()) {
            const name = currentUser().name.split(' ')
            this.name = name[0] || ''
        }
    },

    methods: {
        closeAction () {
            return window.location.href = '/'
        }
    }

}
</script>

<style lang="scss">
    .custom-loading {
        position: static;
    }
</style>
